import { useCallback, useEffect, useState } from "react";
import OccasionCollectionService from "../../../services/OccasionCollectionService";
import { OccasionCollection } from "../../../models";
import OccasionCollectionsTable from "./ui/occasion-collections-table";
import OccasionCollectionsTableSkeleton from "./skeletons/occasion-collections-table-skeleton";

export default function OccasionCollectionsPage() {
  const api = new OccasionCollectionService();
  const [items, setItems] = useState<OccasionCollection[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchItems = useCallback(async (showLoading = false) => {
    try {
      if (showLoading) setLoading(true);
      const data = await api.getOccasionCollections();
      setItems(data);
    } catch (err) {
      console.error("Error fetching occasion collections:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void fetchItems(true);
  }, [fetchItems]);

  return (
    <div className="w-full">
      <div className="flex w-full items-center justify-between">
        <h1 className={` text-2xl`}>Occasion Collections</h1>
      </div>
      {loading ? (
        <OccasionCollectionsTableSkeleton />
      ) : (
        <OccasionCollectionsTable items={items} loading={loading} onChanged={fetchItems} />
      )}
    </div>
  );
}
